var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1735894539732,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4819,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455.52 181.72V145.16a19.14 19.14 0 0 1 19.14-19.16h182.76a42.3 42.3 0 0 1 37.1 62.6l-120 219.78V241.8a59.68 59.68 0 0 0-59.3-59.7z",
    fill: "#FF6B6B",
    "p-id": 4820
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M657.42 126h-182.76a19.16 19.16 0 0 0-19.14 19.16v5.54h160.74a42.3 42.3 0 0 1 37.1 62.6l-78.94 144.46v50.62l120-219.78a42.3 42.3 0 0 0-37-62.6z",
    fill: "#FA5252",
    "p-id": 4821
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M500.84 368.16L395.86 198a24 24 0 0 1 20.4-36.58h147.4a18.5 18.5 0 0 1 18.48 18.58v188.2z",
    fill: "#FF6B6B",
    "p-id": 4822
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M769.26 440.9a423.58 423.58 0 0 0-110.8-130.72c-30.32-2.76-82.14-2.22-112.46-4.98-30.32 2.76-82.14 2.22-112.46 4.98a423.66 423.66 0 0 0-110.8 130.72C302 479.14 272 534.58 276.44 609.66c1.18 20 4.14 61.88 29.76 105.9 57.16 98.14 174.16 116 195.14 119.12a302.9 302.9 0 0 0 89.3 0c20.98-3.18 138-20.98 195.14-119.12 25.64-44 28.58-86 29.76-105.9 4.46-75.08-25.54-130.52-46.28-168.76z",
    fill: "#FF6B6B",
    "p-id": 4823
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M412.36 271.38m36.58 0l194.12 0q36.58 0 36.58 36.58l0 0.04q0 36.58-36.58 36.58l-194.12 0q-36.58 0-36.58-36.58l0-0.04q0-36.58 36.58-36.58Z",
    fill: "#FA5252",
    "p-id": 4824
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M584 482.14a12.12 12.12 0 0 1-15.44-2.7 21.88 21.88 0 0 0-5.48-4.9 29.84 29.84 0 0 0-32.26 2.56 18.96 18.96 0 0 0-7.12 15.12q0 12.58 18.68 20.26l17.12 7Q580.34 528 590 540.14a46.54 46.54 0 0 1 9.68 29.86q0 23.7-15.78 39.16a54.18 54.18 0 0 1-39.48 15.58q-22.36 0-36.92-13.24a54.46 54.46 0 0 1-14.42-22.72 13.3 13.3 0 0 1 9.56-17.44 13.32 13.32 0 0 1 15.56 9.58 25.6 25.6 0 0 0 3.86 8.42q8 11.14 23.36 11.12a27.1 27.1 0 0 0 20.12-8.12 28.1 28.1 0 0 0 8-20.58 28.94 28.94 0 0 0-1.4-9.18 23.32 23.32 0 0 0-4.34-7.68 34.74 34.74 0 0 0-7.62-6.56 73.38 73.38 0 0 0-11.12-5.84l-16.56-6.9q-35.24-14.92-35.26-43.62a41.38 41.38 0 0 1 14.8-32.38q14.78-13.12 36.8-13.12a48.56 48.56 0 0 1 37.82 16.94 12.24 12.24 0 0 1-2.66 18.72z",
    fill: "#FFDEEB",
    "p-id": 4825
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M546 650.88a13.6 13.6 0 0 1-13.6-13.6v-15.46a13.6 13.6 0 1 1 27.2 0v15.46a13.6 13.6 0 0 1-13.6 13.6zM546 463.76a13.6 13.6 0 0 1-13.6-13.6v-15.46a13.6 13.6 0 1 1 27.2 0v15.46a13.6 13.6 0 0 1-13.6 13.6z",
    fill: "#FFDEEB",
    "p-id": 4826
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M888.48 686.98a54.54 54.54 0 0 0-73.84-18.98l-233.02 134a62.36 62.36 0 0 1-52.36 4.56l-64.1-23.16a22.56 22.56 0 0 1-14.88-21.2 22.62 22.62 0 0 1 30.36-21.2l54.32 19.7a53.72 53.72 0 0 0 68.78-32 53.42 53.42 0 0 0-32-68.54l-148-53.68-57.22-16.12a124.76 124.76 0 0 0-79.04 3.8L208.8 624.8v231.88l100-2a124.74 124.74 0 0 1 43.06 6.8L540 926.58a62.36 62.36 0 0 0 51.46-4.88l276.36-159c26.44-15.22 36.4-49.68 20.66-75.72z",
    fill: "#F9BF87",
    "p-id": 4827
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128 578m14.06 0l100.22 0q14.06 0 14.06 14.06l0 280.52q0 14.06-14.06 14.06l-100.22 0q-14.06 0-14.06-14.06l0-280.52q0-14.06 14.06-14.06Z",
    fill: "#20C997",
    "p-id": 4828
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.4 829.96a25.78 25.7 0 1 0 51.56 0 25.78 25.7 0 1 0-51.56 0Z",
    fill: "#96F2D7",
    "p-id": 4829
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M517.04 711a35.36 35.24 0 1 0 70.72 0 35.36 35.24 0 1 0-70.72 0Z",
    fill: "#FFF4E6",
    "p-id": 4830
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance .6e76e5cdad6c458bc8e41bfd100a6228.svg";
export { ForwardRef as ReactComponent };